import { render, staticRenderFns } from "./w2pFileUploader.vue?vue&type=template&id=5d09e4f8"
import script from "./w2pFileUploader.vue?vue&type=script&lang=ts"
export * from "./w2pFileUploader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./w2pFileUploader.vue?vue&type=style&index=0&id=5d09e4f8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports